module.exports = __webpack_public_path__ + "static/media/Еня 4.333e679a.jpg";